var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgErrorIcon = function SvgErrorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.667 5.333H7.333v5.334h1.334V5.333zM8.667 12H7.333v1.333h1.334V12z",
    fill: "#AB5820"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.763 12.916L9.783 1.168A1.978 1.978 0 008 .075c-.706 0-1.411.364-1.782 1.093L.237 12.916C-.482 14.327.543 16 2.127 16h11.746c1.584 0 2.609-1.673 1.89-3.084zm-1.218 1.374a.777.777 0 01-.672.377H2.127a.776.776 0 01-.672-.377.777.777 0 01-.03-.769L7.406 1.773A.65.65 0 018 1.408a.65.65 0 01.594.365l5.981 11.748a.777.777 0 01-.03.77z",
    fill: "#AB5820"
  })));
};
export default SvgErrorIcon;